import i18n from '@/api/i18n/i18n';

export const SHEDULE_TABS = [
  {
    title: i18n.t('settings.schedule.generalSettings'),
    active: true,
  },
  {
    title: i18n.t('settings.schedule.computersAndFrequency'),
    active: false,
  },
  {
    title: i18n.t('settings.schedule.reportSending'),
    active: false,
  },
];
